import { ComicsList } from 'lib/comics';
/** styles **/
import s from '../../styles/organisms/top-comics.module.scss';

import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
/** components **/
import classNames from 'classnames';
import { ContentsTitle } from 'components/molecules';
import { Link } from 'react-router-dom';

export const TopComics: React.FC = () => {

  return (
    <div className={s.topComicsContentsWrapper}>
      <div className={s.contentsTitle}>
        <ContentsTitle title="P-man４コマ劇場" subTitle="4コマ漫画でわかるP-manライフ" />
        <Link className={classNames(s.moreLink, s.pcOnly)} to="/p-man-comic">
          <p>もっとみる</p>
          <GreenCircleArrow className={s.moreLinkIcon} />
        </Link>
      </div>
      <div className={s.comicsContents}>
        <div >
          <div className={s.comicCase}>
            <span>CASE-04</span>
            <p>{ComicsList[0].type}</p>
          </div>

          <div className={s.comicListsWrapper}>
            <div className={classNames(s.comicListWrapper, s.nomal)}>
              <p className={s.label}>
                P-manのない生活
              </p>
              <div className={s.comicList}>
                {ComicsList[0].nomalImages.map((image, imageindex) => (
                  <div className={s.imageWrapper} key={imageindex}>
                    <span>{imageindex + 1}</span>
                    <img key={imageindex} src={require(`assets/images/${image}`)} alt={ComicsList[0].type} />
                  </div>
                ))}
              </div>
            </div>
            <div className={s.comicListWrapper}>
              <p className={s.label}>P-manのある生活</p>
              <div className={s.comicList}>
                {ComicsList[0].images.map((image, imageindex) => (
                  <div className={s.imageWrapper} key={imageindex}>
                    <span>{imageindex + 1}</span>
                    <img key={imageindex} src={require(`assets/images/${image}`)} alt={ComicsList[0].type} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Link className={classNames(s.moreLink, s.spOnly)} to="/p-man-comic">
          <p>もっとみる</p>
          <GreenCircleArrow className={s.moreLinkIcon} />
        </Link>
      </div>
    </div>
  );
};
